import React from 'react';
import moment from 'jalali-moment';

class Jalali extends React.Component<Props> {
  constructor(props) {
    super(props);
    
    this.state = {
      format: this.props.format || 'YYYY/MM/DD',
      date: null,
    }
  }

  fromUnixTimestamp = () => {
    if (this.props.timestamp) {
      const date = moment.unix(this.props.timestamp).locale('fa').format(this.state.format);
      this.setState({date});
    }
  }

  componentDidMount() {
    this.fromUnixTimestamp();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.timestamp !== this.props.timestamp) {
      this.fromUnixTimestamp();
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.state.date}
      </React.Fragment>
    );
  }
}

export {Jalali};
export default Jalali;